import script from "./BaseSearchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSearchInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseSearchInput.vue?vue&type=style&index=0&id=5ea9829e&lang=scss"

const __exports__ = script;

export default __exports__